function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWysuppIconGreenTransparent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 142.5,
    height: 67.1,
    viewBox: "0 0 142.5 67.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.9,49.8H33.6a16.2,16.2,0,0,1,0-32.4h8.3A33.4,33.4,0,0,1,71.3,0H33.6a33.6,33.6,0,1,0,0,67.1H71.3A33.5,33.5,0,0,1,41.9,49.8Z",
    style: {
      fill: "#21b67d",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5,33.6A16.3,16.3,0,0,1,71.3,49.8h29.3a33.3,33.3,0,0,0,0-32.4H71.3A16.2,16.2,0,0,1,87.5,33.6Z",
    style: {
      fill: "#21b67d",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,33.6A16.2,16.2,0,0,1,71.3,17.4H41.9a33.3,33.3,0,0,0,0,32.4H71.3A16.3,16.3,0,0,1,55,33.6Z",
    style: {
      fill: "#21b67d",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.9,0H71.3a33.4,33.4,0,0,1,29.3,17.4h8.3a16.2,16.2,0,0,1,0,32.4h-8.3A33.5,33.5,0,0,1,71.3,67.1h37.6a33.6,33.6,0,1,0,0-67.1Z",
    style: {
      fill: "#21b67d",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.6,49.8H41.9a33.5,33.5,0,0,0,58.7,0Z",
    style: {
      fill: "#21b67d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9,17.4h58.7a33.5,33.5,0,0,0-58.7,0Z",
    style: {
      fill: "#21b67d"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWysuppIconGreenTransparent);
export default __webpack_public_path__ + "static/media/wysupp-icon-green-transparent.984ba56c4fc7c2bdbbd7348da1cb4bcb.svg";
export { ForwardRef as ReactComponent };